import axios from "axios";

export const vehicleReport = (userID, token, vehicleChecks) => {
  const { VIN, moneyOwingCheck, vehicleValueCheck } = vehicleChecks;
  return axios.post(`${process.env.REACT_APP_API_COMMON}create-checkout-session`, { userID, VIN: VIN, moneyOwingCheck: moneyOwingCheck, vehicleValueCheck: vehicleValueCheck },
    { headers: { Authorization: `Bearer ${token}` } }
  );
};